export default "__VITE_ASSET__Cfy4_0Sc__"